window.table = {
    decimalRenderer: (data, type, row) => {
        return helper.formatDecimal(Number(data));
    },

    currencyRenderer: (data, type, row) => {
        return helper.formatCurrency(Number(data));
    },

    dateRenderer: (data, type, row) => {
        return helper.formatDate(data);
    }
};
